export interface SimTipoOption {
    value: 'total' | 'parcela';
    label: string;
}

export const SIM_TIPO_OPTIONS: SimTipoOption[] = [
    { value: 'total', label: 'Por valor total desejado' },
    { value: 'parcela', label: 'Por valor de parcela' },
];

export const PRAZO_DEFAULTS = {
    min: 6,
    max: 36,
    options: [6, 12, 18, 24, 30, 36],
};
